/// <reference types="google.maps" />
import { GooglePlaceAutocomplete } from '@app/services/google/place-auto-complete';
import { cn } from '@shared/lib/utils';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from '../ui/form';
import InputLabel from './input-label';
import { FormProps } from './types';

interface GooglePlacePickerProps extends FormProps {}

export default function GooglePlacePicker({
  name,
  className,
  label,
  placeholder,
  includeErrorMessage = false,
  disabled = false,
  handleSelect,
}: GooglePlacePickerProps) {
  const { control, setValue } = useFormContext();

  const onSelectPlace = (place: google.maps.places.PlaceResult | null) => {
    if (place) {
      setValue(name, place.formatted_address);
      handleSelect && handleSelect(place.formatted_address!);
    }
  };

  return (
    <FormField
      control={control}
      name={name}
      disabled={disabled}
      render={({ field, fieldState }) => {
        return (
          <FormItem
            className={cn('grid items-end w-full border-error', className)}
          >
            {label && <InputLabel label={label} name={name} />}
            <FormControl>
              <GooglePlaceAutocomplete
                onPlaceSelect={onSelectPlace}
                defaultValue={field.value}
                placeholder={placeholder}
                disabled={disabled}
                className={cn('', { 'border-destructive': fieldState.error })}
              />
            </FormControl>
            {includeErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
    />
  );
}
